import angular from 'angular';
class SLVToggle {
  /* @ngInject */
  constructor($log, $http, Endpoints, API_URL, CMS_API_URL) {
    Object.assign(this, {
      $log,
      $http,
      Endpoints,
      API_URL,
      CMS_API_URL
    });
  }

  getAllServices() {
    return this.$http.get(this.API_URL + '/states/UK');
  }

  getAiDermConfig() {
    return this.$http.get(this.Endpoints.aiDerm.getAidermConfig);
  }

  toggleAiDerm(serviceId, source, enabled) {
    const url = source === 'pims'
      ? this.Endpoints.aiDerm.postAiDermPimsToggle.replace(':product_category_id', serviceId)
      : this.Endpoints.aiDerm.postAiDermBrochureToggle.replace(':product_category_id', serviceId)

    return this.$http.put(url, { enabled });
  }

  toggle(category, show_slv_required, show_slv_optional) {
    var payload = {
      slv_required: show_slv_required ? 1 : 0,
      slv_optional: show_slv_optional ? 1 : 0
    };
    return this.$http.put(this.CMS_API_URL + `/admin/slv/UK/${category}`, payload);
  }

  toggle_phone_call_required(category, show_slv_required, phone_call_required) {
    var payload = {
      slv_required: show_slv_required ? 1 : 0,
      phone_call_required: phone_call_required ? 1 : 0
    };
    return this.$http.put(this.CMS_API_URL + `/admin/async_telephone/UK/${category}`, payload);
  }

  toggleDelivery(category_id, pharmacy_option_id, is_visible) {
    const payload = {
      is_visible
    };

    return this.$http.put(this.CMS_API_URL + `/admin/delivery_methods/${pharmacy_option_id}/${category_id}`, payload);
  }

  toggle_batching_enabled(service_id, batching_enabled) {
    const payload = {
      batching_enabled,
    };
    return this.$http.put(this.CMS_API_URL + `/admin/batching_enabled/${service_id}`, payload);
  }
  toggle_service_enabled(service_id, service_enabled) {
    const payload = {
      service_enabled,
    };
    return this.$http.put(this.CMS_API_URL + `/admin/service_enabled/${service_id}`, payload);
  }
}

SLVToggle.$inject = ["$log", "$http", "Endpoints", "API_URL", "CMS_API_URL"];
angular.module('pims').service('SLVToggle', SLVToggle);
